import * as React from 'react';
import { css } from 'aphrodite/no-important';
import Helmet from 'react-helmet';
import { MandatoryAdditionalStyle } from '../../components.utils';
import { ErrorBoundary } from '../../errorHandling/ErrorBoundary';
import { useViewabilityHandler, ViewabilityProvider } from '../../../viewability/viewabilityHandler';
import { setEventEmitter } from '../../components/pageLayouts/eventEmitters/eventEmitters.utils';

interface InjectedBlockDataProps {
    html: string
    script: string | undefined
    dataId: string
}

type InjectedBlockProps = InjectedBlockDataProps & MandatoryAdditionalStyle;

type InjectArticleBlockByIndexCallback = (dataId:string) => void;

const emitInjectArticleBlockByIndexEvent = (dataId:string) => {
  setEventEmitter('injectArticleBlockByIndexEvent', (callback:InjectArticleBlockByIndexCallback) => callback(dataId));
};

const getBlockDataId = (block: Element) => {
  return block.getAttribute('data-id');
};

const sendViewabilityEvent = (element: Element) => {
  const id = getBlockDataId(element);
  setEventEmitter('viewabilityArticleBlockEvent', callback => callback({ id }));
};

export const InjectedBlock: React.FunctionComponent<InjectedBlockProps> = props => {
  const { html, additionalStyle, dataId, script } = props;

  React.useEffect(() => {
    emitInjectArticleBlockByIndexEvent(dataId);
  }, [dataId]);

  const ref = useViewabilityHandler(sendViewabilityEvent, 0.5);
  return (
    <ViewabilityProvider>
      <ErrorBoundary>
        {
       script
         ? (
           <Helmet>
             <script>{script}</script>
           </Helmet>
         ) : null
      }
        {/* eslint-disable-next-line react/no-danger */}
        <figure ref={ref} data-id={dataId} dangerouslySetInnerHTML={{ __html: html }} className={css(additionalStyle.style)} />
      </ErrorBoundary>
    </ViewabilityProvider>
  );
};
